import React, { Component } from "react";
import { Waypoint } from "react-waypoint";
import { isMobile } from "react-device-detect";

import Player from "../Player/Player.js";
import Lock from "../Lock/Lock";
import "./Intro.scss";

class Intro extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    return (
      <>
        <Waypoint
          horizontal
          onEnter={() => {
            this.props.chapterTransition("intro");
          }}
        >
          <div
            className="chapter-intro chapter intro"
            style={{ height: this.state.height + "px" }}
          >
            <div className="section-zero section">
              <h1>
                Velkommen til Barnas skog
                <Player file="intro_1" />
              </h1>
              {isMobile ? (
                <div className="scroll-indication">
                  <span>Denne veien</span>
                </div>
              ) : (
                <div className="scroll-indication desk">
                  <span>Scroll nedover</span>
                  <span>for å bevege deg bortover</span>
                </div>
              )}
            </div>
            <div className="section section-one">
              <h2 className="statement">
                Det er en liten bit skog i alt som er papir
              </h2>
              <div className="content">
                <p>
                  Det kan hende du er mest opptatt av det som er oppi
                  melkekartongen, særlig når den er full av kakaomelk, men
                  visste du at kartongen har en spennende historie?
                </p>
                <p>
                  Melkekartongen er laget av fibre, tynne tråder som er flettet
                  sammen, og disse fibrene kommer fra trær. Fra skogen. Tenk at
                  kartongen du holder i hånda er laget av trær du kan klatre i
                  og gjemme deg bak, fra skoger det bor milliarder av dyr,
                  planter og sopp i!{" "}
                </p>
              </div>
            </div>

            <div className="section section-two">
              <div className="scroll-container one">
                <div className="green-content scroll">
                  <h2>Det er nødvendig å hogge trær.</h2>
                  <p>
                    Vi trenger tømmer for å bygge møbler og hus, vi bruker ved
                    til å fyre i peisen når det er kaldt ute, og både ispinner,
                    tannpirkere, kartong og papir er laget av trær.
                  </p>
                  <p>
                    Tenk at noe som vokser opp av jorda kan bli så mye
                    fantastisk! Hvis du ser deg rundt der du sitter akkurat nå
                    vil du garantert finne noe som er laget av trær.
                  </p>
                </div>
                <Player file="intro_2" />
              </div>
              <div className="scroll-container stumps">
                <div className="scroll scroll-one"></div>
              </div>
            </div>

            <div className="section section-three">
              <div className="scroll-container four">
                <div className="scroll">
                  <p>
                    Når vi hogger ned trær må vi være nøye med at skogen vi
                    henter trestokkene fra blir behandlet på en god måte. Det
                    betyr at vi må sørge for å verne gamle trær, la døde trær
                    ligge igjen, og la nye trær vokse opp. Da vil artene som bor
                    i skogen fortsette å trives der.
                  </p>
                  <h2>
                    Overalt i verden hogges det likevel skog som burde fått lov
                    til å stå i fred.{" "}
                  </h2>
                  <p>
                    Det går ut over artene som bor der. Du kan jo tenke deg
                    selv, hva om noen gikk inn på rommet ditt og fjernet senga
                    di og alle favorittlekene dine, ville du ha trivdes da? Når
                    vi hogger skog uten å ta hensyn til artene som bor der, kan
                    de i verste fall dø ut. Det betyr at de forsvinner for
                    alltid. Det er trist, det!
                  </p>
                </div>
                <Player file="intro_3" />
              </div>

              <div className="scroll-container three">
                <div className="scroll"></div>
              </div>
              <div className="scroll-container one">
                <div className="green-content scroll">
                  <p>
                    Kildesorterer du melkekartongen din, kan vi bruke papiret
                    som allerede er lagd på nytt, og vi slipper å hogge ned like
                    mange trær for å få tak i flere fibre.{" "}
                  </p>
                  <h2>
                    Papirfibrene i melkekartongen kan faktisk gjenvinnes hele
                    sju ganger!
                  </h2>
                </div>
                <Player file="intro_4" />
              </div>
              <div className="scroll-container two">
                <div className="green-content scroll">
                  <p>
                    Det vil si at når du har skylt, bretta og stappa kartongen,
                    og lagt den i beholderen for papir, så kan fibrene leve
                    videre i cornflakes-esker, legoesker, pizzakartonger og
                    dorullkjerner. Samtidig som du sørger for at artene i skogen
                    får leve videre i sus og dus, eller i bark og mose.
                  </p>
                  <h2>
                    Det er derfor vi sier at du skyller, bretter og stapper for
                    skogen!
                  </h2>
                </div>
                <Player file="intro_5" />
              </div>
              <div className="scroll-container cartongs">
                <div className="green-content scroll"></div>
              </div>
              <div className="scroll-container montain">
                <div className="green-content scroll scroll-one"></div>
              </div>
            </div>

            <div className="section section-four">
              <div className="column-one">
                <div className="statement">
                  Ikke alle helter har kapper. Noen av dem har melkebart!
                </div>
              </div>
              <div className="column-two">
                <h2>
                  Dere kan beskytte skogen og alle raringene som bor der, hver
                  eneste gang dere har melkebart.
                </h2>
                <p>
                  Kildesorterer dere skolemelka, bevarer dere skog. Det gjør
                  dere ved å skylle melkekartongen og la den tørke litt. Så gjør
                  dere kartongen så flat som mulig, og sorterer den som
                  papiravfall. Etterhvert som dere gjør det, får dere lære mer
                  om skogen dere redder og alle de små, store, slimete, skumle
                  og søte skapningene som bor der.
                </p>
                <h2>Hvor mange klarer dere å beskytte?</h2>
                <Player file="intro_6" />
              </div>
              <div className="column-three">
                <h2>
                  Gjør dere klare for å skylle, brette og stappe skolemelka for
                  roteskogen!
                  <Player file="intro_7" />
                </h2>
              </div>
            </div>

            <div className="section section-end"></div>
            <Lock progress="one" handleModal={this.props.handleModal}></Lock>
          </div>
        </Waypoint>
      </>
    );
  }
}

export default Intro;
